import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentContainer, ContentHeader } from '../giftcard.styles';

const GiftcardDisabledPage = () => {
  const { t } = useTranslation();

  return (
    <ContentContainer data-testid={'GiftcardDisabledPage.ContentContainer'}>
      <ContentHeader component="h1" variant="h5" noBody>
        {t('eGiftCard.cardDisabled')}
      </ContentHeader>
    </ContentContainer>
  );
};

export default GiftcardDisabledPage;
